module.exports = __webpack_public_path__ + "img/test3.42825957.png";